import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../util/types";

export const hintWrapper = (isFocused: boolean): SxProps => ({
  display: {
    md: "block",

    xs: /* c8 ignore next 1 */ isFocused ? "none" : "block",
  },
});

export const textActionBtnWrapper: SxProps = {
  width: { xs: "auto", md: "50%" },
  position: { xs: "static", lg: "absolute" },
  bottom: {
    sm: null,
    md: "15px",
  },
  right: {
    sm: null,
    md: "15px",
  },
};

export const inputListConatiner: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  width: "100%",
};

export const inputIndexNumber = (theme: ThemeV2): SxProps => ({
  fontSize: theme.tokens.typography.size.lg,
  fontWeight: theme.tokens.typography.weight.bold,
  color: theme.tokens.color.action.primary,
});

export const container = (
  isLandScapeMode: boolean,
  isFocused: boolean,
  orientation?: string,
): SxProps => ({
  display: "flex",
  ...(orientation == "portrait-land"
    ? {
        flexDirection: "column",
        "& > *": {
          flexBasis: "calc(10vh - 100px)",
        },
        // minHeight: /* c8 ignore next 2 */ isFocused ? " 50%" : " 80vh",
      }
    : {
        flexDirection: "row",
        "& > *": {
          flexBasis: "100%",
        },
        height: "100%",
      }),
  justifyContent: "space-between",
  width: "100%",
  gap: {
    md: "20px",
    xs: "20px",
  },
  alignItems: isLandScapeMode ? "center" : "flex-start",
});
